import React, { useState } from "react";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./HelpFAQ.css";

const HelpFAQ = () => {
  const [openItem, setOpenItem] = useState(null);
  const [activeCategory, setActiveCategory] = useState("all");

  const faqs = [
    { id: 1, category: "orders", q: "How do I place an order?", a: "Browse our products, add items to your cart, and proceed to checkout. You'll need to provide your shipping details and select a payment method to complete your order." },
    { id: 2, category: "orders", q: "Can I cancel or modify my order?", a: "You can cancel or modify your order within 1 hour of placing it by contacting our support team. After that, the order may have already been processed for shipping." },
    { id: 3, category: "orders", q: "How do I track my order?", a: "Once your order is shipped, you'll receive a tracking number via email. You can also track your order by logging into your account and visiting 'My Orders'." },
    { id: 4, category: "shipping", q: "How long does delivery take?", a: "Delivery within Bangladesh typically takes 3–5 business days. International shipping may take 10–20 business days depending on your location and customs processing." },
    { id: 5, category: "shipping", q: "Do you offer free shipping?", a: "We offer free shipping on orders above ৳2000 within Bangladesh. International shipping rates vary by destination and are calculated at checkout." },
    { id: 6, category: "payments", q: "What payment methods do you accept?", a: "We accept credit/debit cards, mobile banking (bKash, Nagad, Rocket), PayPal, and cash on delivery for eligible areas within Bangladesh." },
    { id: 7, category: "payments", q: "Is my payment information secure?", a: "Yes, all transactions are encrypted using SSL technology. We never store your full card details and all payments are processed through secure payment gateways." },
    { id: 8, category: "account", q: "How do I create an account?", a: "Click on 'Register' at the top of the page, fill in your details, and verify your email address. Your account will be ready to use immediately." },
    { id: 9, category: "account", q: "I forgot my password. What should I do?", a: "Click 'Forgot Password' on the login page, enter your email address, and we'll send you a link to reset your password within a few minutes." },
    { id: 10, category: "vendors", q: "How do I become a vendor?", a: "Click on 'Register as Vendor' and fill out the vendor registration form with your business details, documents, and bank information. Our team will review and approve your application within 48 hours." },
  ];

  const categories = [
    { key: "all", label: "All Topics", icon: "fa fa-list" },
    { key: "orders", label: "Orders", icon: "fa fa-shopping-cart" },
    { key: "shipping", label: "Shipping", icon: "fa fa-truck" },
    { key: "payments", label: "Payments", icon: "fa fa-credit-card" },
    { key: "account", label: "Account", icon: "fa fa-user" },
    { key: "vendors", label: "Vendors", icon: "fa fa-store" },
  ];

  const filtered = activeCategory === "all" ? faqs : faqs.filter(f => f.category === activeCategory);

  return (
    <div>
      <CartBannerComponent title="Help & FAQ" />
      <div className="container faq-container my-5">

        <div className="row mb-4">
          <div className="col-md-8 mx-auto text-center">
            <h2 className="section-title">Help & Frequently Asked Questions</h2>
            <p className="text-muted">Find answers to common questions about shopping, orders, shipping, and more.</p>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12 d-flex justify-content-center flex-wrap">
            {categories.map(cat => (
              <button
                key={cat.key}
                className={`cat-btn mr-2 mb-2 ${activeCategory === cat.key ? "active" : ""}`}
                onClick={() => { setActiveCategory(cat.key); setOpenItem(null); }}
              >
                <i className={`${cat.icon} mr-1`} />
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        <div className="row">
          <div className="col-md-8 mx-auto">
            {filtered.map((faq) => (
              <div key={faq.id} className="faq-item mb-3">
                <div
                  className={`faq-question d-flex justify-content-between align-items-center ${openItem === faq.id ? "active" : ""}`}
                  onClick={() => setOpenItem(openItem === faq.id ? null : faq.id)}
                >
                  <span>{faq.q}</span>
                  <i className={`fa ${openItem === faq.id ? "fa-minus" : "fa-plus"}`} />
                </div>
                {openItem === faq.id && (
                  <div className="faq-answer">{faq.a}</div>
                )}
              </div>
            ))}

            <div className="still-need-help text-center mt-5 p-4">
              <i className="fa fa-headphones fa-2x mb-3 text-primary" />
              <h5 className="font-weight-bold">Still need help?</h5>
              <p className="text-muted">Our support team is available Sunday–Thursday, 9AM–6PM.</p>
              <a href="/contact-us" className="btn btn-primary px-4">Contact Us</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default HelpFAQ;